import { render, staticRenderFns } from "./TravelsPurposesEmissionsBar.vue?vue&type=template&id=a0028070"
import script from "./TravelsPurposesEmissionsBar.vue?vue&type=script&lang=js"
export * from "./TravelsPurposesEmissionsBar.vue?vue&type=script&lang=js"
import style0 from "./TravelsPurposesEmissionsBar.vue?vue&type=style&index=0&id=a0028070&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports